import React from "react";

import withStyles from '@mui/styles/withStyles';
import classNames from "classnames";

import { OrderStatus } from "../../../util/enums";
import getOrderOptions from "../getOrderOptions";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  classes?: any;
  className?: React.HTMLAttributes<unknown>["className"];
};

const styles = () =>
  ({
    customBadge: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      minWidth: "51px",
      padding: "6px 16px",
      height: "40px",
      borderRadius: "20px",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Inter",
      fontSize: "10px",
      fontWeight: 600,
      lineHeight: "20px",
      whiteSpace: "nowrap",
    },
  } as const);

const SimpleBadge = (props: Props) => {
  const { classes, value, className } = props;

  return (
    <div className={classNames(classes.customBadge, className)}>
      <span className={classes.textValue}>{value}</span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

export const BadgePOStatus = (props: Props) => {
  const { value, ...rest } = props;
  const { orderStatusOptions } = getOrderOptions();

  const label = orderStatusOptions.find((statusOption) => statusOption.value === value)?.label;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          {...rest}
        />
      );

    return <> </>;
  };

  switch (value) {
    case OrderStatus.CONFIRMED:
      return renderBadge("#D1FADF ", "#12B76A", label);
    case OrderStatus.RECEIVED:
      return renderBadge("#EBE9FE", "#6938EF", label);
    case OrderStatus.FULFILLED:
      return renderBadge("#EAECF5", "#344054", label);
    case OrderStatus.CANCELLED:
      return renderBadge("#FEE4E2", "#F04438", label);
    case OrderStatus.CLOSED_FOR_RECEIVING:
      return renderBadge("#F4EBFF", "#7F56D9", label);
    case OrderStatus.CLOSED_FOR_INVOICING:
      return renderBadge("#FEF0C7", "#DC6803", label);
    case OrderStatus.READY_TO_SHIP:
      return renderBadge("#E0F2FE", "#0086C9", label);
    case OrderStatus.PARTLY_LOADED:
    case OrderStatus.LOADED:
      return renderBadge("#E0EAFF", "#444CE7", label);
    case OrderStatus.ASSIGNED:
      return renderBadge("#FCE7F6", "#DD2590", label);
    default:
      return renderBadge("#eafaf9", "#38CFC4", label);
  }
};

export default BadgePOStatus;
